import { useEffect, useState } from 'react';
import { getMonitoringOverview } from '../api/monitoring.api';
import type { MonitoringSnapshot } from '../types/monitoring.types';

export function useMonitoring() {
  const [monitoring, setMonitoring] = useState<MonitoringSnapshot | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getMonitoringOverview()
      .then(setMonitoring)
      .catch(() => setError('خطا در دریافت اطلاعات مانیتورینگ'))
      .finally(() => setLoading(false));
  }, []);

  return { monitoring, loading, error };
}
